import React from 'react';
import _ from 'lodash';
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
} from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { Link } from 'react-router-dom';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

const JobTable = ({
  job,
  page,
  size,
  total,
  handleChangePage,
  handleChangeRowsPerPage,
  handleDelete,
}) => (
  <Paper>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <div className="font-bold">ลำดับที่</div>
            </TableCell>
            <TableCell>
              <div className="font-bold">ชื่องาน</div>
            </TableCell>
            <TableCell>
              <div className="font-bold">ลูกค้า</div>
            </TableCell>{' '}
            <TableCell>
              <div className="font-bold"> จุดเริ่มต้น</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> จุดหมาย</div>
            </TableCell>{' '}
            <TableCell>
              <div className="font-bold"> ราคา</div>
            </TableCell>
            <TableCell>
              <div className="font-bold"> ดำเนินการ</div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!_.isEmpty(job) ? (
            job.map((row, index) => (
              <TableRow
                key={row._id}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {(page - 1) * size + index + 1}
                </TableCell>
                <TableCell>
                  <div className="font-semibold">{row?.name}</div>
                  <div className="flex my-1">
                    {row?.is_fixed_cost ? (
                      <div className="p-2 py-1 rounded-md bg-blue-100 ">
                        คิดราคาคงที่
                      </div>
                    ) : (
                      <div className="p-2 py-1 rounded-md bg-yellow-100 ">
                        ราคาขึ้นตามราคาน้ำมัน
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell>{row?.customer?.name}</TableCell>{' '}
                <TableCell>{row?.start}</TableCell>
                <TableCell>{row?.destination}</TableCell>
                <TableCell>
                  {' '}
                  {!row?.is_fixed_cost ? (
                    <div>{row?.zone_price?.name} </div>
                  ) : (
                    <div>{row?.fixed_cost} บาท</div>
                  )}
                </TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {/* <Link to={`job/view/${row?._id}`}>
                      <Button variant="contained" size="small" color="info">
                        รายละเอียด
                      </Button>
                    </Link>{' '} */}

                    <Link to={`job/edit/${row?._id}`}>
                      <Button variant="contained" size="small" color="warning">
                        แก้ไข
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={() => handleDelete(row?._id)}
                    >
                      ลบ
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6}>
                <div className="text-center">ไม่มีข้อมูล</div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
      component="div"
      onRowsPerPageChange={handleChangeRowsPerPage}
      page={page - 1}
      count={total || 1}
      rowsPerPage={size}
      onPageChange={handleChangePage}
    />
  </Paper>
);

JobTable.propTypes = {
  job: PropTypes.arrayOf(PropTypes.object),
  page: PropTypes.number,
  size: PropTypes.number,
  total: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  handleToInfoPage: PropTypes.func,
  handleToEditPage: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default JobTable;
